import React from 'react';
import Svg, { Mask, Path, Rect, ClipPath, G, Defs } from 'react-native-svg';

export function QnAFilled({ width, height }) {
  return (
    <>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M6.66602 15.6C5.28185 16.7783 4.01602 17.5 1.66602 17.5C2.49935 16.6667 3.55768 15.5417 4.00018 13.7942C2.55518 12.595 1.66602 10.9642 1.66602 9.16667C1.66602 5.485 5.39685 2.5 9.99935 2.5C14.2493 2.5 17.756 5.045 18.2685 8.33333"
          stroke="#368665"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M13.332 16.5742C10.5704 16.5742 8.33203 14.9159 8.33203 12.8701C8.33203 10.8251 10.5704 9.16675 13.332 9.16675C16.0937 9.16675 18.332 10.8251 18.332 12.8701C18.332 13.8692 17.7987 14.7751 16.932 15.4409C17.1962 16.4117 17.832 17.0367 18.332 17.5001C16.832 17.5001 16.0687 17.0467 15.172 16.3151C14.602 16.4817 13.982 16.5742 13.332 16.5742Z"
          fill="#368665"
          stroke="#368665"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </>
  );
}
